export const calculateProductMaxAmount = (redeem_limit, supply_limit, issued_counter, redeemed_count) => {

  return Math.min(
    supply_limit ? supply_limit - issued_counter : Infinity,
    redeem_limit ? redeem_limit - redeemed_count : Infinity
  );
};
